export default "__VITE_ASSET__989d2ffd__"